export default __webpack_public_path__ + "static/media/ClientStats.eeb5aa4e.svg";